// extracted by mini-css-extract-plugin
var _1 = "UHU_wp";
var _2 = "t2fig_";
var _3 = "jvJu2v";
var _4 = "UHU_wp";
var _5 = "t2fig_";
var _6 = "jvJu2v";
var _7 = "bP2jo1";
var _8 = "iJigdj";
var _9 = "kgJ_Ho";
var _a = "iJigdj";
var _b = "kgJ_Ho";
export { _1 as "idFacebook", _2 as "idTwitter", _3 as "idYoutube", _4 as "id__facebook", _5 as "id__twitter", _6 as "id__youtube", _7 as "social", _8 as "socialItem", _9 as "socialLink", _a as "social__item", _b as "social__link" }
